import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  contentGrid: {
    display: 'grid',
    rowGap: '30px',
    columnGap: '32px',
    gridTemplateColumns: 'repeat(4,1fr)',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
};
